export const normalizeBillingMode = value => value === 'RENTAL' ? 'RENTAL' : 'MAINTENANCE';

export const getBillingLabels = value => {
  const isRental = normalizeBillingMode(value) === 'RENTAL';
  return {
    amount: isRental ? 'Rent/Maintenance' : 'Maintenance',
    monthlyAmount: isRental ? 'Monthly Rent/Maintenance' : 'Monthly Maintenance',
    payment: isRental ? 'Rent/Maintenance Payment' : 'Maintenance Payment',
  };
};
